import { render } from "./FilePickerStorageFolder.vue?vue&type=template&id=e3d7b20a&scoped=true"
import script from "./FilePickerStorageFolder.vue?vue&type=script&lang=js"
export * from "./FilePickerStorageFolder.vue?vue&type=script&lang=js"

import "./FilePickerStorageFolder.vue?vue&type=style&index=0&id=e3d7b20a&scoped=true&lang=scss"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3d7b20a"]])

export default __exports__